/**
 * X-Digate Main JavaScript
 * Handles navigation, scroll effects, and core functionality
 */ (function() {
    'use strict';
    // DOM Elements
    const navbar = document.querySelector('.navbar');
    const navbarToggle = document.querySelector('.navbar-toggle');
    const navbarMenu = document.querySelector('.navbar-menu');
    const navbarOverlay = document.querySelector('.navbar-overlay');
    const navLinks = document.querySelectorAll('.navbar-nav-link');
    // State
    let isMenuOpen = false;
    let lastScrollY = 0;
    /**
     * Initialize all functionality
     */ function init() {
        setupNavigation();
        setupSmoothScroll();
        setupScrollEffects();
        setupActiveNavigation();
    }
    /**
     * Setup mobile navigation toggle
     */ function setupNavigation() {
        if (!navbarToggle || !navbarMenu) return;
        navbarToggle.addEventListener('click', toggleMenu);
        if (navbarOverlay) navbarOverlay.addEventListener('click', closeMenu);
        // Close menu on nav link click
        navLinks.forEach((link)=>{
            link.addEventListener('click', closeMenu);
        });
        // Close menu on escape key
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape' && isMenuOpen) closeMenu();
        });
        // Handle resize
        window.addEventListener('resize', debounce(()=>{
            if (window.innerWidth > 1024 && isMenuOpen) closeMenu();
        }, 150));
    }
    /**
     * Toggle mobile menu
     */ function toggleMenu() {
        isMenuOpen = !isMenuOpen;
        navbarToggle.classList.toggle('active', isMenuOpen);
        navbarMenu.classList.toggle('active', isMenuOpen);
        if (navbarOverlay) navbarOverlay.classList.toggle('active', isMenuOpen);
        // Update ARIA
        navbarToggle.setAttribute('aria-expanded', isMenuOpen);
        // Toggle body scroll
        document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    }
    /**
     * Close mobile menu
     */ function closeMenu() {
        if (!isMenuOpen) return;
        isMenuOpen = false;
        navbarToggle.classList.remove('active');
        navbarMenu.classList.remove('active');
        if (navbarOverlay) navbarOverlay.classList.remove('active');
        navbarToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
    }
    /**
     * Setup smooth scroll for anchor links
     */ function setupSmoothScroll() {
        document.querySelectorAll('a[href^="#"]').forEach((anchor)=>{
            anchor.addEventListener('click', function(e) {
                const href = this.getAttribute('href');
                if (href === '#') return;
                const target = document.querySelector(href);
                if (target) {
                    e.preventDefault();
                    const navbarHeight = navbar ? navbar.offsetHeight : 0;
                    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                    // Update URL without jumping
                    history.pushState(null, null, href);
                }
            });
        });
    }
    /**
     * Setup scroll-based effects
     */ function setupScrollEffects() {
        const scrollHandler = throttle(()=>{
            const currentScrollY = window.pageYOffset;
            // Navbar background on scroll
            if (navbar) navbar.classList.toggle('scrolled', currentScrollY > 50);
            lastScrollY = currentScrollY;
        }, 10);
        window.addEventListener('scroll', scrollHandler, {
            passive: true
        });
    }
    /**
     * Update active navigation based on scroll position
     */ function setupActiveNavigation() {
        const sections = document.querySelectorAll('section[id]');
        const updateActiveNav = throttle(()=>{
            const scrollY = window.pageYOffset;
            const navbarHeight = navbar ? navbar.offsetHeight : 0;
            sections.forEach((section)=>{
                const sectionTop = section.offsetTop - navbarHeight - 100;
                const sectionBottom = sectionTop + section.offsetHeight;
                const sectionId = section.getAttribute('id');
                if (scrollY >= sectionTop && scrollY < sectionBottom) navLinks.forEach((link)=>{
                    link.classList.remove('active');
                    if (link.getAttribute('href') === `#${sectionId}`) link.classList.add('active');
                });
            });
        }, 100);
        window.addEventListener('scroll', updateActiveNav, {
            passive: true
        });
    }
    /**
     * Debounce utility function
     */ function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = ()=>{
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
    /**
     * Throttle utility function
     */ function throttle(func, limit) {
        let inThrottle;
        return function(...args) {
            if (!inThrottle) {
                func.apply(this, args);
                inThrottle = true;
                setTimeout(()=>inThrottle = false, limit);
            }
        };
    }
    // Initialize on DOM ready
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    // Expose utilities for other scripts
    window.XDigate = {
        debounce,
        throttle
    };
})();

//# sourceMappingURL=www.xdigate.ai.f5bf25c0.js.map
